import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Layout from "../../containers/Layout";
// import HeaderLayout from "../../containers/headerLayout";
import { AuthContext } from "../../context/AuthContext";
import ErrorModal from "../Modals/ErrorModal";
import { useTranslation } from "react-i18next";

export default function ProtectedRoute() {
  let { user, setUser, isAppTimeout } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return <>{user !== null ? <><Layout />
   {isAppTimeout && <ErrorModal
                deleteError={"Your session has timed out due to inactivity. Please sign in again to continue."}
                errorModal={isAppTimeout}
                buttonTxt={t('_Sign_In_')}
                setErrorModal={()=>{
                  setUser(null)
                  navigate('/auth')
                }}
            />}
  </> : <Navigate to={"/auth"} />}</>;
}
